import Banner from "../../components/banner/Banner";
import "./AboutPage.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet-async";

function AboutPage(props: { isConnect: boolean }) {
  return (
    <>
      {/* === Helmet for SEO === */}
      <Helmet>
        <title>À propos – Cemade</title>
        <meta
          name="description"
          content="Découvre l’histoire de Cemade, son utilité, et ses atouts : solidarité, échange et autonomie."
        />
        <meta property="og:title" content="À propos – Cemade" />
        <meta
          property="og:description"
          content="Cemade est une plateforme solidaire où les voyageurs et les résidents échangent leurs talents sans argent."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://cemade.fr/about" />
        <meta property="og:image" content="https://cemade.frlogo-cemade.png" />
        <meta property="og:image:alt" content="Logo de Cemade - plateforme d’échange de services" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <Banner isConnect={props.isConnect} showBtnHome={true} />

      <h1 className="font-bold text-4xl p-4 text-greenCustom">À propos de Cemade</h1>

      <div className="div-body">
        <div className="flex flex-col md:flex-row justify-between mb-10">
          {/* partie Nom de l'Application et introduction */}
          <section id="app-objectif" className="w-full md:w-1/2 md:pr-4 mb-4">
            <h2 className="mb-2 font-bold text-3xl">Son utilité</h2>

            <p className="text-center">
              Cemade, est la plateforme qui connecte les <strong>voyageurs</strong> et les <strong>résidents</strong> pour échanger des services sans <strong>argent</strong>.<br />
              Tu es de passage dans une région ou bien installé ? <br />
              Propose ce que tu sais faire, découvre les talents autour de toi, et <strong>échange équitablement</strong>.<br />

              🚶‍♂️ <strong>Voyageurs</strong> : trouve rapidement une aide locale où que tu sois.<br />
              🏡 <strong>Résident</strong> : valorise ton temps et ton savoir-faire en aidant ceux de passage..
            </p>

          </section>

          {/* partie Notre histoire */}
          <section id="app-objectif" className="w-full md:w-1/2 md:pl-4 mb-4">
            <h2 className="mb-2 font-bold text-3xl">Son histoire</h2>

            <p className="text-center">
              Que tu sois en fourgon, à sac à dos ou en mode road-trip, voyager est une aventure inoubliable! Pour la rendre encore plus riche, nous avons créé Cemade. <br />Le troc est au cœur de notre projet, un moyen de mettre en relation voyageurs et résidents pour s’entraider. Autrefois, le troc était le premier moyen d’échange, un lien humain précieux. Oublié avec l’arrivée de la monnaie, nous voulons lui redonner sa place et tout son sens dans notre quotidien. </p>
          </section>
        </div>

        {/* partie Les fonctionnalités */}
        <section id="app-features" className=" w-full flex flex-col justify-center my-10 mb-4">
          <h2 className="mb-2 font-bold text-3xl">Ses atouts</h2>
          <p className="text-center">P'tit récap de ce que tu peux faire pendant 1 mois d'abonnement. </p>
          <div className="tableau-container inline-block">
            <table>
              <thead className="thead-about">
                <tr>
                  <th className="case-vide"></th>
                  <th className="th-case-full arrondi" colSpan={2}>Je suis voyageur</th>
                  <th className="th-case-full" colSpan={2}>Je suis résident</th>
                </tr>
              </thead>
              <thead className="thead-about">
                <tr className="case-orange">
                  <th>Atouts:</th>
                  <th className="text-black">BASIC</th>
                  <th className="text-greenCustom">PREMIUM</th>
                  <th className="text-black">BASIC</th>
                  <th className="text-greenCustom">PREMIUM</th>
                </tr>
              </thead>
              <tbody className="tbody-about">
                <tr>
                  <td>Nombre d'éléments à échanger</td>
                  <td>1</td>
                  <td>8 max</td>
                  <td>1</td>
                  <td>8 max</td>
                </tr>
                <tr>
                  <td>Zone de recherche</td>
                  <td>Région actuelle</td>
                  <td>France entière</td>
                  <td colSpan={2}>France entière</td>
                </tr>
                <tr>
                  <td>Discuter</td>
                  <td colSpan={2}><FontAwesomeIcon icon={faCheck} className="text-green-600 text-2xl" /></td>
                  <td colSpan={2}><FontAwesomeIcon icon={faCheck} className="text-green-600 text-2xl" /></td>
                </tr>
                <tr>
                  <td>Accepter une demande</td>
                  <td colSpan={2}><FontAwesomeIcon icon={faXmark} className="text-lightRedCustom text-2xl" /></td>
                  <td>1</td>
                  <td>8 max</td>
                </tr>
                <tr>
                  <td>Nombre de demandes</td>
                  <td colSpan={2}>1 demande à la fois pour chaque élément</td>
                  <td colSpan={2}><FontAwesomeIcon icon={faXmark} className="text-lightRedCustom text-2xl" /></td>
                </tr>
                <tr>
                  <td>Liker un élément à échanger</td>
                  <td colSpan={2}><FontAwesomeIcon icon={faXmark} className="text-lightRedCustom text-2xl" /></td>
                  <td colSpan={2}>Illimité</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p>Besoin de plus de détails ? Consulte la <a href="/faq" className="font-bold text-orangeCustom hover:underline">FAQ</a></p>
        </section>

        {/* partie équipe */}
        <section id="app-team" className="w-full md:w-1/2 mx-auto pb-8">
          <h2 className="mb-2 font-bold text-3xl">L'équipe</h2>

          <p className="text-center">
            Nous sommes une équipe passionnée par la résolution de problèmes grâce au code. Edan, concepteur et développeur d'application web et mobile, est accompagné de Squirrel, développeuse junior. <br />Ensemble, nous sommes prêts à écouter tes suggestions et à améliorer continuellement le projet !
          </p>
        </section>
      </div>
    </>
  )
}
export default AboutPage;

// ✨ Nomade ? Résident ? Échangez ce que vous savez faire, sans ouvrir votre portefeuille.

// 🚶‍♂️ En déplacement ? Obtenez un service sur place.
// 🏡 Sédentaire ? Rentabilise ton temps avec ceux qui passent.

// 💬 Le troc de services, simple, rapide et humain.

// 🔓 Commence gratuitement
// 🔐 Débloque plus avec l’abonnement Premium

// 👉 Rejoins la communauté TrocApp maintenant !